import WidgetStats from 'components/WidgetStats/WidgetStats'

export default WidgetStats
